import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import NextHead from "../components/Seo/NextHead";
import { CriticaLifeBreadcrumb, defBreadcrumb } from "../data/DataBreadcrumb";
import { CriticaLifeMeta } from "../data/DataMetatags";
import BreadcrumbComponent from "../components/UserInterface/BreadcrumbComponent";
import LayoutCenter from "../components/UserInterface/LayoutCenter";
import { ImageComponent } from "../components/UserInterface/ImageComponent";
import CriticaLifeLogo from "../../public/static/images/svg/NewCriticalLifeCoverLogo.svg";
import CriticaLifeIllu from "../../public/static/images/svg/Criticalillustration.svg";
import HeadingComponent from "../components/UserInterface/HeadingComponent";
import Description from "../components/UserInterface/Description";
import { StepsComponent } from "../components/UserInterface/StepsComponent";
import BannerComponent from "../components/UserInterface/BannerComponent";
import CriticalBanner from "../../public/static/images/jpg/CriticalLifeCOVER_Website-Banner.jpg";
import CriticalBannerMobile from "../../public/static/images/jpg/CriticalLifeCOVER_Mini-Web-Banner.jpg";
import { CriticalChoice } from "../components/CriticaLifeCOVER/CriticalChoice";
import UseWindowSize from "../components/UseWindowSize";
import Button from "../components/UserInterface/Button";

const CriticaLifeCOVER = ({
  breadcrumb,
  title,
  description,
  path,
  CriticaLifeBreadcrumb
}) => {
  const [winSize, setWinSize] = useState(null);
  const { width } = UseWindowSize();
  useEffect(() => {
    setWinSize(width);
  }, []);
  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      ></NextHead>
      <BreadcrumbComponent items={CriticaLifeBreadcrumb}></BreadcrumbComponent>
      <BannerComponent
        img={winSize > 600 ? CriticalBanner : CriticalBannerMobile}
        visible
        mobileHeight="100%"
      ></BannerComponent>
      <ImageComponent
        maxWidthImage="260px"
        url={CriticaLifeLogo}
        marginDesktop="64px 16px 0px"
        marginMobile="0px"
      ></ImageComponent>
      <LayoutCenter column alignMobile="flex-start">
        <HeadingComponent
          headingText="Perlindungan untuk Kamu dan Pasanganmu"
          fontWeight="bold"
          justifyMobile
        ></HeadingComponent>
        <Description
          text={`<b>CriticaLifeCOVER</b> merupakan program kerja sama antara PT Home Credit Indonesia dan PT Equity Life Indonesia. Program ini merupakan pemasaran produk asuransi Critical Life Protection yang didukung oleh PT Equity Life Indonesia, dengan memberikan perlindungan atas risiko Meninggal Dunia dan risiko Penyakit Kritis meliputi Stroke, Kanker, dan Serangan Jantung yang memudahkan kamu untuk melindungi diri dan orang terkasih dalam satu kali bayar untuk perlindungan selama 1 tahun.`}
          font="Roboto"
          maxWidth="820px"
          margin="24px 16px 64px "
          marginMobile="16px 16px 32px"
          alignMobile="left"
        ></Description>
        <StepsComponent
          img={CriticaLifeIllu}
          title="Manfaat dan Risiko yang Dilindungi oleh CriticaLifeCOVER"
          subtitle={`1. Meninggal Dunia karena penyakit atau kecelakaan<br>
                    2. Penyakit Kritis (Stroke, Kanker, Serangan Jantung)`}
        />
      </LayoutCenter>
      <CriticalChoice></CriticalChoice>
      <LayoutCenter column>
        <LayoutCenter column margin="8px">
          <Description
            font="Roboto"
            fontSize="24px"
            fontWeight="bold"
            width="460px"
            text="Dapatkan manfaat CriticaLifeCOVER bersama kami"
            fontMobile="16px"
            marginMobile="32px 16px 24px 16px"
            mobileWidth="288px"
          ></Description>
          <Button
            text="Rencanakan Sekarang"
            onClick={() =>
              window.open(
                "https://c4334.app.goo.gl/HhpKaKMEbjgw4Nj56",
                "_blank"
              )
            }
            dataCy="plan-now-cta"
          ></Button>
        </LayoutCenter>
        <div className='contact-container'>
          <div className='contact-title'>
            <h2>Informasi selengkapnya tentang syarat dan
              ketentuan program, layanan klaim, dan keluhan
              dapat menghubungi:</h2>
          </div>
          <div className='contact-section'>
            <div className='contact-information location'>
              <p>PT Equity Life Indonesia</p>
              <p>Sahid Sudirman Center Lantai 43</p>
              <p>Jl. Jenderal Sudirman No 86, Jakarta 10220</p>
              <p>Telepon : 1500 079</p>
              <p>Email : claim.hci@equity.id</p>
            </div>
            <div className='contact-information time'>
              <p>Jam Operasional : Senin - Jumat</p>
              <p>Pukul : 09.00 - 17.00 WIB</p>
              <p>(kecuali hari libur nasional)</p>
            </div>
          </div>
        </div>
        <Description
          font="Roboto"
          fontSize="24px"
          margin="16px"
          fontWeight="bold"
          maxWidth="660px"
          text="Penyedia Program CriticaLifeCOVER"
          fontMobile="16px"
        />
        <Description
          font="Roboto"
          margin="0 0 64px 0"
          width="680px"
          maxWidthMobile="280px"
          text="CriticaLifeCOVER merupakan program kerjasama antara PT Equity Life Indonesia sebagai penyedia jasa asuransi berupa produk Critical Life Protection dan PT Home Credit Indonesia sebagai pihak pemasar asuransi.
          PT Home Credit Indonesia dan PT Equity Life Indonesia berizin dan diawasi oleh Otoritas Jasa Keuangan (OJK)"
        />
      </LayoutCenter>
      <style jsx>{`
        .contact-container{
          text-align: center;
          margin-top: 20px;
        }
        .contact-title{
          width: 498px;
          margin-left: auto;
          margin-right: auto;
        }
        .contact-title h2{
          margin-bottom: 0px;
        }
        .contact-section{
          display: flex;
          justify-content: center;
        }
        .contact-information{
          margin: 20px;
          width: 301px;
        }
        .contact-information p{
          margin: 0px;
        }
        @media only screen and (max-width: 600px) {
          .contact-container{
            text-align: left;
          }
          .contact-title{
            width: 90%;
          }
          .contact-title h2{
            font-size: 16px;
          }
          .contact-section{
            display: block;
          }
          .contact-information{
            width: 90%;
          }
          .contact-information p{
            font-size: 12px;
          }
        }
      `}</style>
    </Layout>
  );
};
export const getStaticProps = async () => {
  const { title, description, path } = CriticaLifeMeta;
  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title
      }
    }
  ];

  return {
    props: { breadcrumb, CriticaLifeBreadcrumb, title, description, path }
  };
};
export default CriticaLifeCOVER;
